import { render } from "./ClinicalSectionDetails.vue?vue&type=template&id=26ad93c0&scoped=true"
import script from "./ClinicalSectionDetails.vue?vue&type=script&lang=js"
export * from "./ClinicalSectionDetails.vue?vue&type=script&lang=js"

import "./ClinicalSectionDetails.vue?vue&type=style&index=0&id=26ad93c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ad93c0"],['__file',"src/components/ClinicalSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26ad93c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26ad93c0', __exports__)) {
    api.reload('26ad93c0', __exports__)
  }
  
  module.hot.accept("./ClinicalSectionDetails.vue?vue&type=template&id=26ad93c0&scoped=true", () => {
    api.rerender('26ad93c0', render)
  })

}


export default __exports__